import { defineAction, object } from '~/prix'
import neighborhoodEditCoverageAreaAction from './geoNeighborhoodEditCoverageArea.action.json' assert { type: 'json' }
// import { z } from 'zod'

const neighborhoodEditCoverageAreaDefinition = defineAction({
  ...neighborhoodEditCoverageAreaAction,

  // input: z.object({
  //   delimitationPolygon: multiPolygon(),
  //   delimitationId: z.number(),
  //   delimitationType: z.enum(['municipality']),
  //   featureCollection: featureCollection(
  //     polygon(),
  //     z.object({
  //       key: z.string(),
  //       id: z.number().or(z.string()).nullish(),
  //       name: z.string(),
  //       alternativeNames: z.array(z.string()),
  //       shape: polygon(),
  //       shapeHighResolution: polygon(),
  //       kind: z.string(),
  //       municipalityId: z.number(),
  //       openStreetMapCode: z.number(),
  //       isCommunity: z.boolean(),
  //       whatsappGroupLink: z.string().nullish(),
  //       latitude: z.number().nullish(),
  //       longitude: z.number().nullish(),
  //       color: z.string().nullish(),
  //     }),
  //   ),
  // }),
  // output: z.object({
  //   success: z.boolean(),
  // }),

  input: object<any>({}),
  output: object<any>({}),
})

export default neighborhoodEditCoverageAreaDefinition
